export const colors = {
  'pink': '#eea7ad',
  'green': '#bee0bf',
  'lavender': '#e1cce2',
  'yellow': '#fbe4c1',
  'purple': '#bbbfe0',
  'tan': '#c7bfa3',
  'blue': '#c9dfe1',
  'grey': '#a1a1aa',
}

export function toUri (path) {
  return path.replace(window.SITE_BASE, '').replace(/^\/+/g, '')
}